// extracted by mini-css-extract-plugin
export default {"component":"TrustpilotModal__component-GADT","starRating":"TrustpilotModal__starRating-spE3"};